import { useNavigate } from "react-router-dom";
import deleteIcon from "../assets/icons/icon-delete.svg";
import ActivityEmpty from "./ActivityEmpty";
import { useEffect, useState } from "react";
import itemService from "../services/ItemService";
import DeleteItem from "./DeleteItem";
import LoadSpiner from "./LoadSpiner";
import { ToastContainer, toast } from "react-toastify";
import icon_info from "../assets/icons/modal-information-icon.svg";
import "react-toastify/dist/ReactToastify.css";

const ActivityItems = (props) => {
  const { activity, fetchActivity } = props;
  const [isModal, setIsModal] = useState(false);
  const [itemDelete, setItemDelete] = useState(null);
  const [itemActivity, setItemActivity] = useState(activity);
  const navigate = useNavigate();
  const options = { year: "numeric", month: "long", day: "numeric" };

  const redirectToDetail = (id) => {
    return navigate(`/detail/${id}`);
  };

  const resetModalDelete = () => {
    setIsModal(false);
    setItemDelete(null);
  };
  const setDeleteActivity = (data) => {
    setItemDelete(data);
    modalToggle();
  };

  const modalToggle = () => {
    setIsModal(!isModal);
  };
  const deleteActivity = () => {
    itemService.deleteActivity(itemDelete.id).then((res) => {
      res.status === 200 && fetchActivity();
      toast.info(
        <div data-cy="modal-information" className="flex flex-row gap-2">
          <img data-cy="modal-information-icon" src={icon_info} />{" "}
          <h3 data-cy="modal-information-title">Activity Berhasil dihapus</h3>
        </div>,
        {
          icon: false,
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        }
      );
    });
    resetModalDelete();
  };

  useEffect(() => {
    setItemActivity(activity);
  }, [activity]);
  return (
    <>
      <ToastContainer />
      <div className="flex flex-wrap mt-5">
        {itemActivity === null ? (
          <div className="flex justify-center items-center w-full h-[calc(100vh-200px)]">
            <LoadSpiner />
          </div>
        ) : itemActivity.length ? (
          itemActivity.map((item) => {
            return (
              <div key={item.id} className="w-1/1 sm:w-1/2 md:w-1/3 lg:w-1/4">
                <div className="flex flex-col justify-between w-full sm:w-40 h-40 m-2.5	md:w-60 md:h-60 bg-white rounded-lg shadow-[0_4px_8px_rgba(0,0,0,.15)] p-6">
                  <div
                    onClick={() => redirectToDetail(item.id)}
                    data-cy="activity-item"
                  >
                    <h3
                      data-cy="activity-item-title"
                      onClick={() => redirectToDetail(item.id)}
                      className="text-sans text-sm font-bold cursor-pointer text-gray-900 mb-4 md:text-lg"
                    >
                      {item.title}
                    </h3>
                  </div>
                  <div className="flex flex-row justify-between">
                    <p data-cy="activity-item-date" className="text-gray-500">
                      {new Date(item.created_at).toLocaleDateString(
                        "id-ID",
                        options
                      )}
                    </p>
                    <img
                      onClick={() => setDeleteActivity(item)}
                      className="cursor-pointer"
                      data-cy="activity-item-delete-button"
                      src={deleteIcon}
                      alt="delete"
                    />
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="flex justify-center items-center w-full">
            <ActivityEmpty />
          </div>
        )}
      </div>
      {isModal && (
        <DeleteItem
          item={itemDelete}
          isModal={isModal}
          reset={resetModalDelete}
          destroy={deleteActivity}
        />
      )}
    </>
  );
};
export default ActivityItems;
